import React from "react";
import { useNavigate } from "react-router-dom";

const Course = ({ user }) => {
  const navigate = useNavigate();
const getStatusColor = (status) => {
  switch (status) {
    case 'active':
      return 'from-green-300 to-green-200 hover:from-green-600 hover:to-green-400';
    case 'inactive':
      return 'from-yellow-300 to-yellow-200 hover:from-yellow-600 hover:to-yellow-400';
        
    default:
      return 'from-blue-300 to-blue-200 hover:from-blue-600 hover:to-blue-400';
  }
};
  const handleCardClick = () => {
    // Redirect to a dummy route
    sessionStorage.setItem("scrollPositionme", document.querySelector("main")?.scrollTop || 0);

    navigate(`/userdetails/${user.user_name}`); 
  };

 
 return (
  <div
    onClick={handleCardClick}
    className={`
      group
      w-[190px] 
      shadow-lg rounded-2xl p-4
      flex flex-col justify-center cursor-pointer
      hover:shadow-xl transition-shadow duration-300
      bg-gradient-to-r ${getStatusColor(user.status)}
    `}
  >
    <label className="text-xs">User Name</label>
    <p className="w-full text-center group-hover:text-white">
      {user.user_name}
    </p>
      <label className="text-xs mt-2">Display Name</label>
     <p className="w-full text-center group-hover:text-white">
      {user.full_name}
    </p>

   <label className="text-xs mt-2">Status</label>
     <p className="w-full text-center group-hover:text-white">
      {user.status}
    </p> 
    
 
     <p className="mt-2 w-full text-center group-hover:text-white">
      {user.allowed_pages.length}
    </p> 
    <label className="text-xs "> allowed pages</label>
  </div>
);

};

export default Course;
